module.exports = __webpack_public_path__ + "static/wle-hero-full-7c8dd561a1119a334bd6889abeb80524.jpg";